import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { ToolBar } from "../../core/components/toolBar";
import { Helper } from "../../core/util/helper";
import { KeyValuePair } from "../../commonInterfaces";
import React from "react"
enum Type {
    Address = 0,
    Machine = 1,
    Ticket = 2,
    Project = 3,
    Assignment = 4,
    Resource = 5,
    Contact = 6,
    Material = 7,
    AllReports = 8,
    ServiceReport = 9,
    WeeklyReport = 10,
    TravelReport = 11,

    Passport = 12,
    Training = 13,
    Visa = 14,
    Tool = 15,
    Vaccination = 16,
    WorkPermits = 17,
    SocialSecurity = 18,
    Dislocations = 19,

    CustomTemplate = 20,
    CustomHeaderAndFooter = 21,
    CashExpense = 22
}

interface TypeItem extends KeyValuePair<Type, string> {
    Table: string;
}

export default class EditObjectTypes extends React.Component<EditObjectTypesProps, EditObjectState> {
    private dialogRef: EditObjectTypesDialog;
    private dataSource: TypeItem[] = [
        {
            Key: Type.Address,
            Value: Helper.getTranslation("Adresse.Adresse"),
            Table: "VKUNADR"
        },
        {
            Key: Type.Machine,
            Value: Helper.getTranslation("BrowserTitle.Machine.Available"),
            Table: "MAPARK"
        },
        {
            Key: Type.AllReports,
            Value: Helper.getTranslation("WebSMS.Report.ReportTemplates"),
            Table: "LBKOPF"
        },
        {
            Key: Type.Assignment,
            Value: Helper.getTranslation("BrowserTitle.Assigment.Available"),
            Table: "PLANUNG"
        },
        //{
        //    Key: Type.Contact,
        //    Value: "Contact",
        //    Table: "VKUNPART"
        //},
        {
            Key: Type.Material,
            Value: Helper.getTranslation("Artikel.Artikel"),
            Table: "MATART"
        },
        {
            Key: Type.Project,
            Value: Helper.getTranslation("BrowserTitle.Project.Available"),
            Table: "KUNDE"
        },
        {
            Key: Type.Resource,
            Value: Helper.getTranslation("BrowserTitle.Resource.Available"),
            Table: "RESSLIST"
        },
        {
            Key: Type.ServiceReport,
            Value: Helper.getTranslation("BrowserTitle.Report.Available"),
            Table: "LBKOPF(SR)"
        },
        {
            Key: Type.Ticket,
            Value: Helper.getTranslation("BrowserTitle.Ticket.Available"),
            Table: "PROBLEME"
        },
        {
            Key: Type.TravelReport,
            Value: Helper.getTranslation("WebSMS.TravelReport.TravelReport"),
            Table: "LBKOPF(TR)"
        },
        {
            Key: Type.WeeklyReport,
            Value: Helper.getTranslation("WebSMS.ReportMetadata.TargetEntity.WeeklyReport"),
            Table: "LBKOPF(WR)"
        },
        {
            Key: Type.Passport,
            Value: Helper.getTranslation("WebSMS.Resource.Reisepass.Passport"),
            Table: "RESSPASS"
        },
        {
            Key: Type.Training,
            Value: Helper.getTranslation("WebSMS.Resource.Schulung"),
            Table: "RESSCHUL"
        },
        {
            Key: Type.Visa,
            Value: Helper.getTranslation("WebSMS.Resource.Visa"),
            Table: "RESSVISA"
        },
        {
            Key: Type.Tool,
            Value: Helper.getTranslation("WebSMS.Resource.Werkzeug"),
            Table: "RESSWERK"
        },
        {
            Key: Type.Vaccination,
            Value: Helper.getTranslation("WebSMS.Resource.Impfung"),
            Table: "RESSIMPF"
        },
        {
            Key: Type.WorkPermits,
            Table: "RESSGENEHM",
            Value: Helper.getTranslation("WebSMS.Resource.Arbeitsgenehmigung")
        },
        {
            Key: Type.SocialSecurity,
            Table: "RESSSOZIAL",
            Value: Helper.getTranslation("WebSMS.Resource.Sozialversicherung")
        },
        {
            Key: Type.Dislocations,
            Value: Helper.getTranslation("WebSMS.Resource.Versetzung"),
            Table: "RESSVERSETZ"
        },
        {
            Key: Type.CustomTemplate,
            Value: Helper.getTranslation("WebSMS.Report.Template"),
            Table: "CR_TEMPLATE"
        },
        {
            Key: Type.CashExpense,
            Value: Helper.getTranslation("WebSMS.ServiceReport.Barauslagen"),
            Table: "LBBAR"
        }
        //{
        //    Key: Type.CustomHeaderAndFooter,
        //    Value: Helper.getTranslation("WebSMS.Report.Report.HeaderFooter.HeaderAndFooter"),
        //    Table: ""
        //}
    ]; 

    private buttonIds = {
        add: "add",
        remove: "remove"
    }
    
    constructor(props: EditObjectTypesProps) {
        super(props)
        this.dataSource = this.dataSource.sort(this.sortTypeItems);
        this.state = {
            gridItems: this.dataSource.filter(item => props.value.findIndex(f => f == item.Key) > -1),
            selectedItem: null
        }
    }

    private sortTypeItems = (a: TypeItem, b: TypeItem) => {
        if (a.Value < b.Value) {
            return -1;
        }
        if (a.Value > b.Value) {
            return 1;
        }
        return 0;
    }

    private setValue = (items: TypeItem[]) => {
        items = items.sort(this.sortTypeItems);
        this.setState({ gridItems: items }, () => {
            this.props.onChange(this.props.field, items.map(item => item.Key))
        })
    }

    private createToolBar = () => {
        let customButtons = [
            { caption: Config.translations.add, enabled: true, iconClass: "far fa-plus-circle", id: this.buttonIds.add },
            { caption: Helper.getTranslation("Standard.Entfernen"), enabled: Helper.hasValue(this.state.selectedItem), iconClass: "far fa-minus-circle", id: this.buttonIds.remove },
        ];
        return (
            <>
                <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleClickCustomButton} />
            </>
        );
    }

    private handleClickCustomButton = (buttonId: string) => {
        switch (buttonId) {
            case this.buttonIds.add:
                this.dialogRef.openDialog();
                break;
            case this.buttonIds.remove:
                const result = this.state.gridItems.filter(item => item.Key != this.state.selectedItem.Key);
                this.setState({ selectedItem: null }, () => {
                    this.setValue(result);
                })
                break;
        }
    }

    private createGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridItems}
                    options={this.props.field.props.gridOptions}
                    onSelectionChanged={this.onSelectionChanged}
                    id="editObjectTypes"
                />
            </div>
        );
    }

    private onSelectionChanged = (dataItem: TypeItem) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ selectedItem: dataItem })
        }
    }

    private createText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className="fal fa-globe-europe fa-10x" style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {Helper.getTranslation("Dokument.ForAllTargetTypes")}
                    </label>
                </div>
            </div>
        );
    }

    private createDialog = () => {
        return <>
            <EditObjectTypesDialog
                dataSource={this.dataSource}
                onOk={this.onOk}
                ref={(ref) => { this.dialogRef = ref }}
            />
        </>
    }

    private onOk = (values: Type[]) => {
        const newValues = this.dataSource.filter(item => values.findIndex(f => f == item.Key) > -1)
        const result = Helper.mergeLists(newValues, this.state.gridItems);
        this.setValue(result)
    }

    render() {
        const grid = this.state.gridItems.length > 0 ? this.createGrid() : this.createText();
        const toolBar = this.createToolBar();
        const dialog = this.createDialog();
        return (
            <div>
                {toolBar}
                {grid}
                {dialog}
            </div>
        );
    }
}

interface EditObjectTypesProps {
    field: {
        props: {
            gridOptions: any
        }
    };
    onChange: (field, value: Type[]) => void;
    value: Type[];
}

interface EditObjectState {
    gridItems: TypeItem[];
    selectedItem: TypeItem;
}

class EditObjectTypesDialog extends React.Component<EditObjectTypesDialogProps, EditObjectTypesDialogState>{

    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.ReportMetadata.TargetEntityType"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ dialogOpen: false })

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.setState({ dialogOpen: false }, () => {
                        this.props.onOk(this.state.values)
                    })
                },
                primary: true
            }
        ],
        width: 500
    };

    constructor(props: EditObjectTypesDialogProps) {
        super(props)
        this.state = {
            dialogOpen: false,
            values: []
        }
    }

    openDialog = () => {
        this.setState({ dialogOpen: true, values: [] })
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createField()}
                </Dialog>
            </>
        );
    }

    private createField = () => {
        const props: MultiselectProps = {
            values: this.state.values,
            dataSource: this.props.dataSource,
            onChange: (values: Type[]) => {
                this.setState({ values: values })
            }
        }
        return (
            <>
                <Multiselect {...props} />
            </>
        );
    }

    render() {
        return this.state.dialogOpen ? this.createDialog() : null;
    }
}

interface EditObjectTypesDialogProps {
    dataSource: TypeItem[];
    onOk: (types: Type[]) => void
}

interface EditObjectTypesDialogState {
    dialogOpen: boolean;
    values: Type[];
}

class Multiselect extends React.Component<MultiselectProps>{
    private multiSelectRef: any;
    private multiSelect: kendo.ui.MultiSelect;

    constructor(props: MultiselectProps) {
        super(props);
    }

    private build = () => {
        this.multiSelect = $(this.multiSelectRef).kendoMultiSelect({
            value: this.props.values,
            enable: true,
            dataSource: this.props.dataSource,
            tagTemplate: "<div>#=data.Value#</div>",
            itemTemplate: "<table cellspacing='0' style='table-layout:fixed; width:350px'><colgroup><col style='width: 200px' /><col style='width: 150px' /></colgroup><tr style='background-color: inherit'><td style='vertical-align:top'>${data.Value}</td><td style='vertical-align:top'>${data.Table}</td></tr></table>",
            clearButton: true,
            change: (ev) => {
                const keys = ev.sender.value().map((x) => { return x.Key });
                this.props.onChange(keys)
            },
            dataTextField: "Value",
            filter: "contains"
        }).data("kendoMultiSelect");
    }

    componentDidMount() {
        this.build();
    }

    render() {
        let style: React.CSSProperties = {
            width: "100%"
        };
        return (
            <div>
                <select ref={(r) => this.multiSelectRef = r} style={style} />
            </div>
        );
    }
}

interface MultiselectProps {
    dataSource: TypeItem[];
    onChange: (values: Type[]) => void;
    values: Type[]
}